import React, { useState } from 'react';
import { Spin } from 'antd';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { EventTicketOptionsListProps } from '../types/bot.types';
import CollapsibleResultGroup from './CollapsibleResultGroup';
import TicketOptionsContainer from '../../../modules/SportsAndEventsPage/components/TicketOptions/TicketOptionsContainer';
import EventTitleAndReview from '../../../modules/SportsAndEventsPage/components/EventTitleAndReview/EventTitleAndReview';
import '../../../modules/SportsAndEventsPage/components/TicketOptions/ticketOptions.less';
import '../../../modules/SportsAndEventsPage/sportsAndEventsPage.less';

const EventTicketOptionsList: React.FC<EventTicketOptionsListProps> = ({
  raw,
  onSelect,
  disabled = false,
  pickLabel,
}) => {
  const t = useSelector((s: RootState) => (s.config.translations as any)?.bot);
  const [selectingTicketId, setSelectingTicketId] = useState<string | number | null>(null);
  const event = raw?.event;
  const tickets: any[] = Array.isArray(raw?.tickets) ? raw.tickets : [];
  const addingLabel = t?.addingToCart ?? 'Adding to cart…';

  if (!event || !tickets.length) return null;

  const handleSelectTicket = ({
    ticket,
    quantity,
    deliveryMethod,
  }: {
    ticket: any;
    quantity: number;
    deliveryMethod: any;
  }) => {
    if (disabled) return;
    setSelectingTicketId(ticket.id);
    const ticketName = ticket.categoryName ?? ticket.name ?? 'Ticket';
    const deliveryName = deliveryMethod?.name ?? 'Delivery';
    const friendlyText = `Add ${quantity} × ${ticketName} (${deliveryName}) to my cart`;
    onSelect(
      {
        ticket_id: ticket.id,
        quantity,
        delivery_method_id: deliveryMethod.id,
      },
      friendlyText,
      ticketName,
    );
  };

  const body = (
    <div
      className={`bot-event-ticket-options${
        selectingTicketId != null ? ' bot-event-ticket-options--selecting' : ''
      }`}
    >
      <EventTitleAndReview
        event={event}
        agentCommissionInfo={raw?.agent_additional_info}
      />
      <div className="ticket-options-wrapper">
        <TicketOptionsContainer
          event={event}
          tickets={tickets}
          handleSelectTicket={handleSelectTicket}
        />
      </div>
      {selectingTicketId != null && (
        <div className="bot-result-card-wrapper__overlay" role="status" aria-live="polite">
          <Spin size="small" />
          <span className="bot-result-card-wrapper__overlay-label">{addingLabel}</span>
        </div>
      )}
    </div>
  );

  if (!disabled) return body;

  return (
    <CollapsibleResultGroup
      icon="🎫"
      title={t?.collapsed?.title?.event ?? 'Ticket options'}
      count={tickets.length}
      pickLabel={pickLabel}
    >
      {body}
    </CollapsibleResultGroup>
  );
};

export default EventTicketOptionsList;
